import Link from "next/link";
import { formatCardDate, type BlogPost } from "@/lib/blog";

// The .blog-item card from the CodeIgniter blog.php view, unchanged in markup
// so style.css keeps styling it.

export default function BlogCard({ post, delay = ".3s" }: { post: BlogPost; delay?: string }) {
  const href = `/blog/${post.slug}`;
  return (
    <div className="col-sm-6 col-lg-4 wow fadeInUp" data-wow-delay={delay}>
      <div className="blog-item">
        <div className="blog-top">
          <Link href={href}>
            <img src={post.image || "/assets/img/logotho.png"} alt={post.heading} />
          </Link>
        </div>
        <div className="blog-bottom">
          <h3>
            <Link href={href}>{post.heading}</Link>
          </h3>
          <p>{post.description}</p>
          <ul>
            <li>
              <Link href={href}>
                Read More <i className="icofont-long-arrow-right" />
              </Link>
            </li>
            <li>
              <i className="icofont-calendar" /> {formatCardDate(post.date)}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
